import { ChangeEvent, useRef } from "react";
import { Spinner } from "react-bootstrap";

interface ImageUploaderProps {
  onFilesSelected: (files: File[]) => void;
  multiple?: boolean;
  accept?: string;
  disabled?: boolean;
  isUploading?: boolean;
  label?: string;
  className?: string;
}

export const ImageUploader = ({
  onFilesSelected,
  multiple = true,
  accept = "image/*",
  disabled = false,
  isUploading = false,
  label = "Upload images",
  className = "",
}: ImageUploaderProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      onFilesSelected(Array.from(files));
    }
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <div className={className}>
      <input
        ref={inputRef}
        type="file"
        className="form-control"
        accept={accept}
        multiple={multiple}
        onChange={handleChange}
        disabled={disabled || isUploading}
      />
      {isUploading && (
        <div className="mt-2 text-center">
          <Spinner animation="border" size="sm" /> Uploading...
        </div>
      )}
    </div>
  );
};
